import React from "react";

import { AuthProvider } from "./context/AuthContext";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import Router from "./router/Router";
import { LocalizationProvider } from "@mui/x-date-pickers";

const App = () => {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </LocalizationProvider>
    </>
  );
};

export default App;
